export default function buildCriteriaQuery(criteriaQuery) {
  if (criteriaQuery) {
    let criterias = '';
    for (let key in criteriaQuery) {
      if (criteriaQuery.hasOwnProperty(key)) {
        if (criterias.length > 0) {
          criterias += '&';
        }
        criterias += key + '=' + criteriaQuery[key];
      }
    }

    return '&' + criterias;
  }
  return '';
}
